import React from 'react';
import PropTypes from 'prop-types';
import CardCallout from './CardCallout';

interface Props {
  posaGiftCardRedeemUrl: string;
  showDesc: boolean;
}

const GiftcardBox = ({posaGiftCardRedeemUrl, showDesc}: Props) => {
  return (
    <CardCallout
      boxClass="giftcard"
      title={'epic.code.redemption.posa.giftcard.title'}
      desc={showDesc ? 'epic.code.redemption.posa.giftcard.desc' : ''}
      redeemLink={posaGiftCardRedeemUrl}
      imgSrc="https://cdn2.unrealengine.com/fn-giftcard-5dbdc8b86ecb.svg"
    />
  );
};

GiftcardBox.propTypes = {
  posaGiftCardRedeemUrl: PropTypes.string,
  showDesc: PropTypes.bool,
};

export default GiftcardBox;
